import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';

Vue.use(Router);

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            component: Home,
        },
        {
            path: '/about',
            component: () => import('./views/About.vue'),
        },
        {
            path: '/contact',
            component: () => import('./views/Contact.vue'),
        },
        {
            path: '/login',
            beforeEnter() {
                window.location.href = 'https://vault.lockio.ch/login';
            }
        },
        {
            path: '/register',
            beforeEnter() {
                window.location.href = 'https://vault.lockio.ch/signup';
            }
        },
        {
            path: '/*',
            component: Home,
        },
    ],
    scrollBehavior(to) {
        if (to.path === '/about' || to.path === '/contact') {
            return {x: 0, y: 0};
        }
    }
});

export default router;
